<template>
  <tr>
    <td>{{ data.work_type.name }}</td>
    <td>{{ data.work_type.measure }}</td>
    <td v-if="(data.size - data.done) <= 0">0,00</td>
    <td v-else>{{$formatCurrency(data.size - data.done)}}</td>
    <td>{{ $formatCurrency(data.price) }}</td>
    <td>{{ $formatCurrency(data.total) }}</td>
  </tr>
</template>

<script>
export default {
  name: "PlanningTableWorkShowItemInner",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
}
</script>

<style scoped>

</style>
